import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  CircularProgress,
  Alert,
} from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import ScheduleIcon from '@mui/icons-material/Schedule'
import PublicIcon from '@mui/icons-material/Public'
import { useAppTranslation } from 'src/admin/core/hooks'
import { useScreensContext } from '../ScreensContext'

const ConfiguracionGeneral = () => {
  const { label } = useAppTranslation()
  const { enterprise, loadingSharedData: loading, sharedDataError: error } = useScreensContext()

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        {error}
      </Alert>
    )
  }

  return (
    <Box sx={{ maxWidth: 900 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
        {label('CONFIGURACION_GENERAL_TITULO')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        {label('CONFIGURACION_GENERAL_SUBTITULO')}
      </Typography>

      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
        {/* Schedule de Ejecución */}
        <Card variant="outlined" sx={{ flex: 1, minWidth: 320 }}>
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
              <ScheduleIcon color="primary" />
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {label('SCHEDULE_DE_EJECUCION')}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="overline" sx={{ color: 'text.secondary', fontSize: '0.65rem' }}>
                  {label('HORA_INICIO')}
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  type="time"
                  value={enterprise?.schedule?.startTime || '08:00'}
                  sx={{ mt: 0.5 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <AccessTimeIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography variant="overline" sx={{ color: 'text.secondary', fontSize: '0.65rem' }}>
                  {label('HORA_FIN')}
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  type="time"
                  value={enterprise?.schedule?.endTime || '22:00'}
                  sx={{ mt: 0.5 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <AccessTimeIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography variant="overline" sx={{ color: 'text.secondary', fontSize: '0.65rem' }}>
                {label('ZONA_HORARIA')} (Timezone)
              </Typography>
              <FormControl fullWidth size="small" sx={{ mt: 0.5 }}>
                <Select value={enterprise?.schedule?.timezone || 'America/New_York'}>
                  <MenuItem value="America/New_York">America/New_York</MenuItem>
                  <MenuItem value="America/Chicago">America/Chicago</MenuItem>
                  <MenuItem value="America/Los_Angeles">America/Los_Angeles</MenuItem>
                  <MenuItem value="America/Santo_Domingo">America/Santo_Domingo</MenuItem>
                  <MenuItem value="Europe/London">Europe/London</MenuItem>
                  <MenuItem value="Europe/Madrid">Europe/Madrid</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </CardContent>
        </Card>

        {/* Infraestructura */}
        {/* <Card variant="outlined" sx={{ flex: 1, minWidth: 320 }}>
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
              <PublicIcon color="primary" />
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {label('INFRAESTRUCTURA')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="overline" sx={{ color: 'text.secondary', fontSize: '0.65rem' }}>
                {label('BASE_URL_ASSIGNMENTS')}
              </Typography>
              <TextField 
                size="small" 
                fullWidth 
                value={enterprise?.base_url || ''} 
                sx={{ mt: 0.5 }} 
              />
              <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block', fontStyle: 'italic' }}>
                {label('BASE_URL_ASSIGNMENTS_HELP')}
              </Typography>
            </Box>
          </CardContent>
        </Card> */}
      </Box>
    </Box>
  )
}

export default ConfiguracionGeneral
